import React from "react";
import HeroBanner from "../components/DynamicHero";
import Intro from "../components/safe-coatings/Intro";
import Features from "../components/safe-coatings/Features";
import EshopCoatings from "../components/safe-coatings/EshopCoatings";
import { useTranslation } from "react-i18next";

const SafeCoatingsPage = () => {
  const { t } = useTranslation("common");
  return (
    <>
      <HeroBanner text={t("navSafeCoatings")} />
      <Intro />
      <Features />
      <EshopCoatings />
    </>
  );
};

export default SafeCoatingsPage;
